import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SEARCH_DOCUMENS_FEATURE_KEY, SearchDocumentsState } from './search.reducer';

export const selectSearchDocumentsState = createFeatureSelector<SearchDocumentsState>(SEARCH_DOCUMENS_FEATURE_KEY);

export const selectSearchDocumentsLoaded = createSelector(
  selectSearchDocumentsState,
  (state: SearchDocumentsState) => state.loaded
);

export const selectSearchDocumentsError = createSelector(
  selectSearchDocumentsState,
  (state: SearchDocumentsState) => state.error
);

export const selectSearchDocuments = createSelector(
  selectSearchDocumentsState,
  (state: SearchDocumentsState) => state.results
);

export const selectSearchDocumentsFilters = createSelector(
  selectSearchDocumentsState,
  (state: SearchDocumentsState) => state.filters
);

export const selectSearchDocumentsCurrentPage = createSelector(
  selectSearchDocumentsState,
  (state: SearchDocumentsState) => state.current_page
);

export const selectSearchDocumentsQueryString = createSelector(
  selectSearchDocumentsState,
  (state: SearchDocumentsState) => state.query
);

export const selectSearchDocumentsTotalItems = createSelector(
  selectSearchDocumentsState,
  (state: SearchDocumentsState) => state.total_items
);
